import React, { Component } from 'react';
import MessageBubble from './MessageBubble';
import { getFormattedDate } from '../utils/amaia-helpers';
import Pictogram from '../../pictogram';

class ChatHistory extends Component {
  constructor(props) {
    super(props);
    this.chatScrollRef = React.createRef();
    this.scrollTimeout = null;
    this.todayDate = new Date();
  }

  componentDidMount() {
    this.scrollToBottom(true);
  }

  componentDidUpdate(prevProps) {
    const { isTyping, messages } = this.props;
    if (messages.length !== prevProps.messages.length || isTyping !== prevProps.isTyping) {
      const isStreaming = messages.length === prevProps.messages.length;
      this.scrollToBottom(isStreaming);
    }
  }

  componentWillUnmount() {
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
  }

  render() {
    const { currentStorefront, isSignedIn, isTyping, messages, userFirstName } = this.props;
    const formattedDate = getFormattedDate(this.todayDate, currentStorefront);

    return (
      <div className='AmaiaChat-main is-chat-active' ref={ this.chatScrollRef }>
        <div className='AmaiaChat-conversation'>
          <div className='AmaiaChat-date-separator'>
            <span>{ formattedDate }</span>
          </div>
          { messages.map((msg) => (
            <MessageBubble
              isSignedIn={ isSignedIn }
              key={ msg.id }
              msg={ msg }
              userFirstName={ userFirstName }
            />
          )) }
          { isTyping && (
            <div className='bubble--amaia'>
              <Pictogram
                className='bubble-avatar-amaia'
                id='AmaiaAvatarStatic'
              />
              <div className='bubble-text'>
                <Pictogram
                  className='AmaiaChat-typing-indicator'
                  id='AmaiaTypingIndicator'
                />
              </div>
            </div>
          ) }
        </div>
      </div>
    );
  }

  scrollToBottom = (instant = false) => {
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

    const scroll = () => {
      const chatContainer = this.chatScrollRef.current;
      if (chatContainer) {
        chatContainer.scrollTo({
          behavior: instant ? 'auto' : 'smooth',
          top: chatContainer.scrollHeight,
        });
      }
    };

    window.requestAnimationFrame(scroll);

    if (!instant) {
      this.scrollTimeout = setTimeout(scroll, 150);
    }
  }
}

export default ChatHistory;
